// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import t from 'tcomb';

const ClaimValueOfRepair = t.struct({
    coreValues: t.Number,
    currency: KeyValuePair,
    laborTotal: t.Number,
    laborValue: t.Number,
    onShelfCost: t.Number,
    otherCreditTotal: t.Number,
    partValues: t.Number,
    partsTotal: t.Number,
    totalAmount: t.Number,
    travel: t.Number
}, {
    name: 'ClaimValueOfRepair',
    strict: true
});

export const getDefaultState = () => new ClaimValueOfRepair({
    coreValues: 0,
    currency: getKeyValueDefaultState(),
    laborTotal: 0,
    laborValue: 0,
    onShelfCost: 0,
    otherCreditTotal: 0,
    partValues: 0,
    partsTotal: 0,
    totalAmount: 0,
    travel: 0
});

export default ClaimValueOfRepair;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-value-of-repair.js